import { Box, Paper, Typography } from '@mui/material'
import PopperItem from '@/core/layouts/header/PopperItem.tsx'
import unlock from '@/assets/images/unlock.svg'
import calculator from '@/assets/images/calculator.svg'
import useCalculator from '../../../../modules/utilities/calculator/components/calculator/hooks/useCalculator.ts'
import useUninstallApp from '../../../../modules/utilities/uninstallApp/components/uninstallApp/hooks/useUninstallApp.ts'
import useHasPermissions from '@/core/hooks/useHasPermissions.ts'

const ToolsMenuContainer = () => {
  const { openModal: openCalculator } = useCalculator()
  const { openModal: openUninstall } = useUninstallApp()
  const { hasPermissions } = useHasPermissions()

  const uninstallAllowed = hasPermissions(['SALES_TOOLBOX:DESINSTALAR'])
  const calculatorAllowed = hasPermissions(['SALES_TOOLBOX:CALCULADORA'])

  const both = uninstallAllowed && calculatorAllowed

  return (
    <Paper
      sx={{
        width: both ? '214px' : '107px',
        height: '113px',
        display: 'grid',
        gap: '6px',
        p: '10px',
        gridTemplateColumns: both ? '1fr 1fr' : '1fr'
      }}
    >
      {[
        {
          name: 'Desinstalar APP',
          icon: unlock,
          action: openUninstall,
          allowed: uninstallAllowed
        },
        {
          name: 'Calculadora',
          icon: calculator,
          action: openCalculator,
          allowed: calculatorAllowed
        }
      ]
        .filter((app) => app.allowed)
        .map((app, i) => (
          <PopperItem key={i} onClick={app.action}>
            <Box
              component="img"
              src={app.icon}
              sx={{
                width: '40px',
                height: '40px',
                aspectRatio: '1/1',
                objectFit: 'contain'
              }}
            ></Box>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ maxWidth: '100%', textAlign: 'center' }}
            >
              {app.name}
            </Typography>
          </PopperItem>
        ))}
    </Paper>
  )
}

export default ToolsMenuContainer
